<script>
	import CtaWithCaption from '../CtaWithCaption/CtaWithCaption.svelte';

	/** @type {String} */
	export let title;
	/** @type {String} */
	export let ctaCaption;
	/** @type {String} */
	export let ctaHref;
	/** @type {String} */
	export let ctaLabel;
	/** @type {{ disclaimer: string }[]} */
	export let disclaimers;
	/** @type {{ number: string; description: string }[]} */
	export let numbersList;
	/** @type {number} */
	export let totalOffersPool;
	/** @type {number} */
	export let uniqueOffersPool;
</script>

<section class="impressive-numbers">
	<div class="inner">
		<h2 class="title">{@html title}</h2>

		{#if numbersList?.length}
			<div class="numbers-box">
				{#each numbersList as { number, description }}
					<a class="number" href="/odkrywaj?utm_source=start&utm_content=impressive_numbers">
						<h3>
							{number.replace('{{uniqueOffersPool}}', `${uniqueOffersPool}`)}
						</h3>

						<p>{@html description.replace('{{totalOffersPool}}', `${totalOffersPool}`)}</p>
					</a>
				{/each}
			</div>
		{/if}

		<CtaWithCaption caption={ctaCaption} href={ctaHref} label={ctaLabel} />

		{#if disclaimers?.length}
			<ul class="disclaimers">
				{#each disclaimers as { disclaimer }}
					<li>
						{@html disclaimer}
					</li>
				{/each}
			</ul>
		{/if}
	</div>
</section>

<style>.impressive-numbers{padding:2.5rem 1.5rem}.inner{display:grid;grid-gap:2.25rem;gap:2.25rem;max-width:var(--layout-width);margin:auto}.number h3,.number p,.title{color:hsla(var(--hsl-primary))}.number p,.title{font:var(--f-heading-sm-semibold);text-align:center}@media (min-width:767.02px){.title{font:var(--f-heading-lg-semibold)}}.numbers-box{align-content:start;align-items:start;background:hsla(var(--hsl-white));border:2px solid hsla(var(--hsl-primary));border-radius:1.25rem;display:grid;grid-gap:1.5rem;gap:1.5rem;padding:2rem 1.75rem}@media (min-width:767.02px){.numbers-box{grid-template-columns:repeat(auto-fit,minmax(12rem,1fr))}}.number{display:grid;grid-gap:.25rem;gap:.25rem;align-items:start;justify-items:center;place-items:start center;-webkit-text-decoration:none;text-decoration:none}.number h3{font:var(--f-heading-xxl-extrabold)}.number p{color:hsla(var(--hsl-black));font:var(--f-paragraph-sm-medium)}.number p :global(strong){color:hsla(var(--hsl-primary))!important;font-weight:bolder}.disclaimers{display:grid;align-content:center;justify-content:center;place-content:center;list-style:none}.disclaimers li{color:hsla(var(--hsl-gray-extra-dark));font:var(--f-ui-xs-regular);margin-bottom:.75rem}</style>
